import { useEffect, useState } from "react"
import { useLocation } from "react-router";


export const useCampaign = () => {
    const [campaign, setCampaign] = useState(undefined);
    const location = useLocation();

    useEffect(() => {
        function buildCampaignObject(campaignAssigObj) {
            if(campaignAssigObj.isNonDeere === null || campaignAssigObj.isNonDeere === undefined){ //For Older Campaigns before creating this new column
                campaignAssigObj.isNonDeere = false;
            }
            if (campaignAssigObj && campaignAssigObj.assignments !== undefined) {
                setCampaign(campaignAssigObj);
            } else if (campaignAssigObj && campaignAssigObj.campaignId && campaignAssigObj.supplierNo) {
                const assigment = {
                    id: campaignAssigObj.id,
                    supplierNumber: campaignAssigObj.supplierNo,
                    status: campaignAssigObj.status
                }
                setCampaign({
                    id: campaignAssigObj.campaignId,
                    assignments: [assigment],
                    status: campaignAssigObj.campaignstatus,
                    endDate: campaignAssigObj.endDate !== undefined ? campaignAssigObj.endDate : ""
                })
            }
            else {
                if (campaignAssigObj) {
                    const supplierNumber = location.state.supplierName !== undefined ? location.state.supplierName.split('-')[0] : ""
                    let assignment = {};
                    if(Array.isArray(campaignAssigObj.assignmentUpdateDetails) && campaignAssigObj.assignmentUpdateDetails.length > 0){
                        let tempObj = campaignAssigObj.assignmentUpdateDetails.find((asgn) => asgn.id === location.state.rn);
                        if(tempObj) {
                            assignment = {...tempObj};
                        }
                    }
                    setCampaign({
                        id: campaignAssigObj.id,
                        endDate: campaignAssigObj.endDate !== undefined ? campaignAssigObj.endDate : "",
                        status: campaignAssigObj.status,
                        assignments: assignment ? [{
                            ...assignment,
                            supplierNumber: supplierNumber,
                            status: campaignAssigObj.status
                        }] : []
                    }
                    )
                }
            }
        }

        buildCampaignObject(location.state.campaign);
    }, [location])

    return campaign
}